<template>
	<div class="My">
		<van-sticky>
		<div class="top skin_bgcolor">
			<van-icon name="setting-o" @click.stop="toSetting" class="setting" size="20px"/>
			<van-cell>
				<van-image
				  round
				  slot="icon"
				  class="err-image-header"
				  :src="userinfo.u_headportrait.indexOf('http')==-1?(attach_url+userinfo.u_headportrait):userinfo.u_headportrait"/>
				<template slot="title">
					<span>{{userinfo.u_nickname}}</span>
				</template>
				<template slot="label">
					<div class="name">{{'柿子号：'+userinfo.u_login_id}}</div>
					<div class="code">{{'邀请码：'+userinfo.u_code}}</div>
				</template>
				<template slot="default">
					<span @click="toMyInfo"><van-icon name="arrow" size="20px"/></span>
				</template>
			</van-cell>
		</div>
		</van-sticky>

		<van-cell-group class="list mt-1" is-link v-for="(litem,index) in listItem" :key="'o_'+index">
			<van-cell is-link v-for="(item,index) in litem" :key="'i_'+index" @click="directto(item)">
				<template slot="icon">
					<img :src="item.icon" />
				</template>
				<template slot="title">{{item.title}}</template>
				<template slot="default" v-if="item.count">
				  {{item.count}}
				</template> 
				<van-tag style="margin-top:15px;" v-if="item.code&&countUnread[item.code]>0"  round type="danger">
					{{countUnread[item.code]}}
				</van-tag>
			</van-cell>
		</van-cell-group>

		<!-- 声音提醒 -->
		<audio controls="controls" hidden src="./static/mp3/msg.wav" ref="altaudio"></audio>
  </div>
</template>
<script>
import { Sticky  } from "vant";
export default {
	name: "My",
	components: {
		"van-sticky": Sticky
	},
	data() {
		return {
			title: "",
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			countUnread:{circle:JSON.parse(localStorage.getItem("circlecountUnread")),message:0,order:0}, 
			userinfo: [],
			listItem: [
				[
					/**
					{
						icon: require("../../assets/img/icon/menu/sign.png"),
						title: "签到",
						to: "/Sign"
					},
					*/
					{
						code:'circle',
						icon: require("../../assets/img/icon/menu/circle.png"),
						title: "熟柿圈",
						to: "/NeighbourMoments"
					},
					{
						code:'message',
						icon: require("../../assets/img/icon/menu/message.png"),
						title: "信息中心",
						to: "/Message",
					},
					{
						icon: require("../../assets/img/icon/menu/notice.png"),
						title: "公告",
						to: "/Notice",
					},
					{
						icon: require("../../assets/img/icon/menu/service.png"),
						title: "联系客服",
						to: "/Service",
					}
				],[
					{
						icon: require("../../assets/img/icon/menu/remind.png"),
						title: "日程提醒",
						to: "/Remind",
					},
					{
						icon: require("../../assets/img/icon/menu/collection.png"),
						title: "收藏中心",
						to: "/Favorites",
					}
				],[
					{
						icon: require("../../assets/img/icon/menu/store.png"),
						title: "店铺管理",
						to: "/StoreManage",
					},
					{
						icon: require("../../assets/img/icon/menu/order.png"),
						title: "订单中心",
						to: "/Order",
					}
				]
			],
			winH: null,
			attach_url: this.Conf.serverPre,
			newmsgList:JSON.parse(localStorage.getItem("newmsgList")),
			msgshowLists:JSON.parse(localStorage.getItem("msgshowLists")),
			msgshowList:[],
			chkWebsocketTimer:false
		};
	},
	created() {
		this.getStateConfigs();
		this.chkSocketState();
   
		this.loadData();
		this.getCountInfoUnread();
		if(JSON.parse(localStorage.getItem("msgshowLists"))){
			this.msgshowList=JSON.parse(localStorage.getItem("msgshowLists"));
		}
	},
	methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		// 初始化页面数据
		loadData() {
			this.userinfo = JSON.parse(localStorage.getItem("userInfo"));
		},
		directto(item){
			if(item.code == "circle"){
				this.toNeighbourMoments();
			}else{
				this.$router.push({path:item.to});
			}
		},
		// 跳转到个人信息页
		toMyInfo() {
			this.$router.push({
				name: "MyInfo",
			});
		},
		toSetting() {
			this.$router.push({
				path: "/Set",
			});
		},
		toNeighbourMoments(){
			var unreadlike = JSON.parse(localStorage.getItem("unreadlike"));
			var unreadcomment = JSON.parse(localStorage.getItem("unreadcomment"));
			var circlecountUnread = JSON.parse(localStorage.getItem("circlecountUnread"));
			if (unreadlike) {
				unreadlike.forEach((item) => {
					if ( item.unreadNumber != 0 && circlecountUnread >0) {
						circlecountUnread = circlecountUnread- item.unreadNumber;
						item.unreadNumber = 0;
					}
				});
				localStorage.setItem("circlecountUnread", JSON.stringify(circlecountUnread));
				localStorage.setItem("unreadlike", JSON.stringify(unreadlike));
			}
			if (unreadcomment) {
				unreadcomment.forEach((item) => {
					if (item.unreadNumber != 0) {
						circlecountUnread = circlecountUnread- item.unreadNumber;
						item.unreadNumber = 0;
					}
				});
				localStorage.setItem("circlecountUnread", JSON.stringify(circlecountUnread));
				localStorage.setItem("unreadcomment", JSON.stringify(unreadcomment));
			}
			this.$router.push({
				name: "NeighbourMoments",
			});
		},
		// // 监听socket消息回调
		getMessage(msg) {
			console.log('my',msg)
			var that = this;
			var data = JSON.parse(msg.data);
			if (data && data.m_type == "alert") {
				that.$toast(data.m_post_messages);
				return;
			}
		 
			switch (data.status) {
				case 1:
				case 2:
					// 重新连接socket fd改变，客户端与服务端token相等时，不退出登入
					if (this.token == data.token) {
						return;
					}
					// 用户在别处登录，客服端与服务端token不相等时
					// 客户端token 与 后台token不相等时，退出登入
					window.localStorage.clear();
					that.$dialog
					.alert({
					  message: data.message,
					})
					.then(() => {
						that.$router.push({ path: "/login" });
					});
					break;
				case 3:
					that.websocket.recordUnreadChat(data);
					//播放声音
					if(data.tag == "one"){
						var noDisturbing = localStorage.getItem( data.data.m_from_user_id + "noDisturbing" );

						if (that.u_id != data.data.m_from_user_id && noDisturbing != 1) {
							// console.log("当前chat播放音乐用户id：" + that.u_id);
							that.$refs.altaudio.currentTime = 0; //从头开始播放提示音
							that.$refs.altaudio.play(); //播放
						}
					}else if (data.tag == "group") {
						var groupNoDistrrbing = localStorage.getItem( data.ug_id + "groupNoDistrrbing" );
						if ( that.u_id != data.data[0].gm_from_id && groupNoDistrrbing != 1
						) {
							// console.log("当前chat播放音乐用户id：" + that.u_id);
							that.$refs.altaudio.currentTime = 0; //从头开始播放提示音
							that.$refs.altaudio.play(); //播放
						}
					}
					that.websocket.staticsMsgUnread();
					break;
				case 6:
					that.websocket.recordUnreadShareLike();
					that.countUnread.circle = that.websocket.staticsShareUnread();
					break;
				case 7:
					that.websocket.recordUnreadShareComment(data);
					that.countUnread.circle = that.websocket.staticsShareUnread();
					break;
				default:
					break;
			}
		},
		chkSocketState() {
			if ( this.websocket && this.websocket.ws && this.websocket.ws.readyState == 1 ) {
				// 监听消息回调
				this.websocket.ws.onmessage = this.getMessage;
			}
			this.chkWebsocketTimer && clearTimeout(this.chkWebsocketTimer)
			this.chkWebsocketTimer = setTimeout(() => {
				this.chkSocketState();
			}, 2000);
		},
		getCountInfoUnread() {
			var par = {
				u_id: this.u_id,
				token: this.token
			};
			var url = this.Conf.serverUrl + "User/countInfoUnread?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(par))
			.then(response => {
				switch (response.data.code) {
					case 200:
						this.countUnread.message = response.data.nums;
						break;
					case 40001:
					  break;
				}
			})
			.catch(error => {
			  // console.log(error);
			});
		}
	},
	beforeDestroy: function () {
		this.chkWebsocketTimer && clearTimeout(this.chkWebsocketTimer)
	}
};
</script>




// WEBPACK FOOTER //
// src/components/My/My.vue